module.exports = __webpack_public_path__ + "img/icon-csv.c1a551e3.svg";